import invariant from 'invariant';
import groupBy from "ramda/es/groupBy";
import includes from "ramda/es/includes";
import omit from "ramda/es/omit";
import prop from "ramda/es/prop";
import { asyncScheduler, pipe } from 'rxjs';
import { buffer, filter, map, pairwise, throttleTime, withLatestFrom } from 'rxjs/operators';
import { getDeepPath } from '../../utils/data';
import { invariantFieldArray } from '../../utils/invariant';
export const filterByActionType = (...matchTypes)=>filter(({ type })=>includes(type, matchTypes));
export const omitValidations = omit([
    'validations'
]);
export const groupByFieldRecord = groupBy(prop('fieldRecord'));
export const getFieldDescriptorWithInvariant = (formDescriptor, fieldName)=>{
    const fieldDescriptor = formDescriptor[fieldName];
    invariant(fieldDescriptor, `cannot find fieldDescriptor for fieldName ${fieldName}`);
    return fieldDescriptor;
};
const resolveFieldDescriptor = (fieldIndices, fieldDescriptor, formDescriptor)=>{
    const base = omitValidations(fieldDescriptor);
    return {
        ...base,
        deepPath: getDeepPath(formDescriptor, base, fieldIndices)
    };
};
export const enhanceWithResolvedFieldDescriptor = (formDescriptor$, { fieldName, fieldIndices } = {})=>pipe(withLatestFrom(formDescriptor$), map(([action, formDescriptor])=>{
        const resolvedFieldName = fieldName ?? action?.meta?.fieldName;
        invariant(resolvedFieldName, 'cannot enhance action with field descriptor, because fieldName is undefined');
        const resolvedFieldIndices = fieldIndices ?? action?.meta?.fieldIndices;
        const fieldDescriptor = getFieldDescriptorWithInvariant(formDescriptor, resolvedFieldName);
        invariantFieldArray(fieldDescriptor, resolvedFieldName, resolvedFieldIndices);
        return {
            ...action,
            meta: {
                ...action.meta,
                fieldDescriptor: resolveFieldDescriptor(resolvedFieldIndices, fieldDescriptor, formDescriptor)
            }
        };
    }));
export const shallowStateNotEqual = (prevState, nextState)=>prevState !== nextState;
export const skipWhenStateEqual = (compareEquality = shallowStateNotEqual)=>pipe(pairwise(), filter(([prevState, nextState])=>compareEquality(prevState, nextState)), map(([, nextState])=>nextState));
export const bufferControl = (control$, actionFilter, time = 100, trailing = true)=>{
    const resolvedFilter = typeof actionFilter === 'string' ? filterByActionType(actionFilter) : actionFilter;
    return pipe(resolvedFilter, buffer(control$.pipe(resolvedFilter, throttleTime(time, asyncScheduler, {
        leading: false,
        trailing
    }))));
};
